  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("search-box");
    const wrapper = document.querySelector(".main-search-article_wrapper");
    const articles = document.querySelectorAll(".search-article");
    const faqCount = document.getElementById("faq-count");
    const suggestions = document.querySelectorAll(".search-suggestion");
    const suggestionsMain = document.querySelector(".search-suggestions-main");
    const showMoreBtn = wrapper.querySelector(".show_more_btn");
    const clearBtn = document.querySelector('.faq-search-wrapper .clearBtn');

    let matchedArticles = [];
    let visibleCount = 20;
    if(suggestions){
        suggestions.forEach(suggestion => {
          suggestion.addEventListener("click", function () {
            const text = this.textContent.trim();
            searchInput.value = text;
            searchInput.dispatchEvent(new Event("input"));
          });
        });
    }

    function highlightText(element, query) {
      const regex = new RegExp(`(${query})`, "gi");
      element.innerHTML = element.textContent.replace(regex, `<mark>$1</mark>`);
    }

    function renderArticles() {

      articles.forEach(a => a.style.display = "none");

      matchedArticles.slice(0, visibleCount).forEach(article => {
        article.style.display = "block";
      });


      if (visibleCount < matchedArticles.length) {
        showMoreBtn.style.display = "block";
      } else {
        showMoreBtn.style.display = "none";
      }

      faqCount.textContent = matchedArticles.length;
    }

    searchInput.addEventListener("input", function () {
      const query = this.value.trim().toLowerCase();
      matchedArticles = [];
      visibleCount = 20;

      clearBtn.style.display = query ? "block" : "none";

      if (query === "") {
        wrapper.style.display = "none";
        suggestionsMain.style.display = "block";
        faqCount.textContent = 0;
        articles.forEach(article => {
          article.classList.remove("clamped", "read_btn");
          article.style.display = "block";
        });
        showMoreBtn.style.display = "none";
        return;
      }

      articles.forEach((article) => {
        const question = article.querySelector(".search-question");
        const content = article.querySelector(".search-content");


        question.innerHTML = question.textContent;
        content.innerHTML = content.textContent;

        const text = question.textContent.toLowerCase() + " " + content.textContent.toLowerCase();

        if (text.includes(query)) {
          article.classList.add("clamped");
          matchedArticles.push(article);

          highlightText(question, query);
          highlightText(content, query);

          requestAnimationFrame(() => {
            if (content.scrollHeight > content.clientHeight) {
              article.classList.add("read_btn");
            } else {
              article.classList.remove("read_btn");
            }
          });
        } else {
          article.classList.remove("clamped", "read_btn");
        }
      });

      wrapper.style.display = matchedArticles.length > 0 ? "block" : "none";
      suggestionsMain.style.display = matchedArticles.length > 0 ? "none" : "block";

      renderArticles();
    });
    
    showMoreBtn.addEventListener("click", function () {
      visibleCount += 20;
      renderArticles();
    });

    clearBtn.addEventListener("click", function () {
      searchInput.value = "";
      clearBtn.style.display = "none";
      searchInput.dispatchEvent(new Event("input"));
    });
  });